<dx-tag-box
  #tagbox
  [items]="data"
  [value]="selectedItems"
  [valueExpr]="key"
  [showSelectionControls]="true"
  [displayExpr]="displayValue"
  [searchEnabled]="enableSearch"
  [searchExpr]="displayValue"
  searchMode="contains"
  applyValueMode="useButtons"
  [maxDisplayedTags]=maxDisplayedTags
  [showMultiTagOnly]="false"
  [multiline]="false"
  (onValueChanged)="valueChanged($event)"
  [placeholder]="placeholder"
  [(value)]="selectedItems"
  [readOnly]="readOnly"
>
</dx-tag-box>
